import React from 'react';
import ReactDOM from 'react-dom';

/**
 * @param {string} targetId
 * @param {string} html
 */
export async function injectAngularFragment(targetId, html) {
    const selector = '#' + targetId;
    const target = $(html).filter(selector);

    if (target.length === 0) {
        throw new Error(`Target element (${selector}) is not present in the given HTML fragment`);
    }

    return new Promise(resolve => {
        npg.ngApp.util.injectHtml(targetId, target, resolve);
    });
}

export function callAngularMethod(targetId, methodName, ...args) {
    const selector = '#' + targetId;
    const target = $(selector);

    if (target.length === 0) {
        throw new Error(`Target element (${selector}) is not present in the current document`);
    }

    const scope = target.scope();

    if (!scope) {
        throw new Error(`Target element (${selector}) does not have an Angular scope`);
    }

    if (typeof scope[methodName] !== 'function') {
        throw new Error(
            `"${methodName}" is not a method in the scope of the target element (${selector})`
        );
    }
    scope[methodName].apply(null, args);
}

export function reactComponentDirective(component) {
    return function() {
        return {
            scope: {
                props: '='
            },
            link: function (scope, element) {
                const Component = component;

                scope.$watch('props', (newProps) => {
                    ReactDOM.render(<Component {...newProps} />, element[0]);
                });

                scope.$on('$destroy', () => {
                    ReactDOM.unmountComponentAtNode(element[0]);
                });
            }
        };
    }
}